module.exports = __webpack_public_path__ + "img/checkbox.1b8b7316.svg";